import { updateConfigList } from '@src/api/aiAlerts';
import { useMutation, useQueryClient } from 'react-query';
import { CONFIG_LIST_KEY } from './alertsQueryKey.constants';

export const useUpdateConfigList = (onMutateSuccess, onMutateError) => {
  const queryClient = useQueryClient();

  return useMutation(updateConfigList, {
    onSuccess: () => {
      onMutateSuccess();
      queryClient.invalidateQueries(CONFIG_LIST_KEY);
    },
    onError: () => {
      onMutateError();
      queryClient.invalidateQueries(CONFIG_LIST_KEY);
      throw new Error('Error deleting custom dimensions');
    }
  });
}
